export const LAYOUT_BREAKPOINTS = {
  MOBILE: 679,
  TABLET: 1024,
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 992,
  XLARGE: 1200,
};
